var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardsStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2743 7.36262C11.3607 6.46537 12.4968 6.13145 13.0549 6.83925L16.2812 10.9305C16.5189 11.2319 16.9081 11.3706 17.2828 11.2875L22.3696 10.1598C23.2496 9.96471 23.9182 10.942 23.4176 11.6916L20.5235 16.0241C20.3103 16.3433 20.2986 16.7564 20.4935 17.0871L23.1379 21.5764C23.5954 22.353 22.8726 23.291 22.005 23.0464L16.9901 21.6329C16.6207 21.5288 16.2242 21.6453 15.9699 21.9328L12.5175 25.835C11.9202 26.5101 10.8048 26.1125 10.7693 25.2118L10.564 20.0056C10.5489 19.6221 10.3155 19.281 9.96353 19.128L5.18542 17.0504C4.35879 16.691 4.39228 15.5073 5.23791 15.1952L10.1258 13.3912C10.4859 13.2583 10.7382 12.9309 10.775 12.5489L11.2743 7.36262Z",
    fill: "#6AC7BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3382 0.578584C16.9638 2.2303 16.854 5.74782 17 7.5C17 6.66236 18.6242 4.63906 20.1719 2.92665C20.4999 2.56384 20.0613 1.96935 19.6239 2.18805C19.3373 2.33137 19 2.12294 19 1.80247V0.883095C19 0.494448 18.5867 0.279829 18.3382 0.578584Z",
    fill: "#6AC7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9785 1.94484C22.5364 2.3938 20.0648 5.60599 19.0458 7.33119C19.5838 6.58006 22.4001 5.86929 24.9743 5.38098C25.5311 5.27536 25.5408 4.41589 24.9833 4.31434C24.6238 4.24887 24.4549 3.83146 24.6676 3.53441L25.333 2.60533C25.5561 2.29382 25.3553 1.87556 24.9785 1.94484Z",
    fill: "#6AC7BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsStar);
export default __webpack_public_path__ + "static/media/rewardsStar.9f5178d463af3c33bc829c50cf121534.svg";
export { ForwardRef as ReactComponent };